define([
	"dojo/_base/declare",
	"csi/action/MoveController",
	"csi/locale"
], function(declare,MoveController,locale) {

	return declare(MoveController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		preProcess: function() {
			this.widget.highlight(this.refNode, false, true);
			this.inherited(arguments);
		},
		
		postProcess: function(bStatus) {	
			var	view = this.widget;
			
			view.highlight(this.refNode, true, true);
		
			if (bStatus && this.refNode) {
				view.deleteRow(this.refNode);
			}
		
			this.inherited(arguments);
		}
	});
});